export default __webpack_public_path__ + "static/media/Imprimante_3D.06238554.png";